"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _share = _interopRequireDefault(require("cccisd-icons/share3"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "copyText", function (text) {
      (0, _copyToClipboard["default"])(text);
      (0, _cccisdNotification["default"])({
        message: 'Resource copied successfully!',
        type: 'success',
        duration: 8000
      });
    });
    return _this;
  }
  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        displayOptions = _this$props.displayOptions,
        name = _this$props.name,
        url = _this$props.url;
      var formatUrl = url.replace(/\s/g, '%20');
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].icon,
          style: displayOptions.shareButtonColor ? {
            color: displayOptions.shareButtonColor
          } : {}
        }, /*#__PURE__*/_react["default"].createElement(_share["default"], null), " ", !displayOptions.showShareIconOnly && /*#__PURE__*/_react["default"].createElement("p", null, "Share")),
        title: 'Share resource for "' + name + '"',
        size: "large"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].shareRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].url
      }, url), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary btn-sm",
        onClick: function onClick() {
          return _this2.copyText(formatUrl);
        }
      }, /*#__PURE__*/_react["default"].createElement(_copy["default"], {
        spaceRight: true
      }), "Copy link")));
    }
  }]);
  return Component;
}(_react["default"].Component);
exports["default"] = Component;
_defineProperty(Component, "propTypes", {
  name: _propTypes["default"].string,
  url: _propTypes["default"].string,
  displayOptions: _propTypes["default"].object.isRequired
});